import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      navigate("/login");
      return;
    }
    localStorage.setItem("odc_token", token);
    api.get("/auth/me")
      .then((r) => {
        login(token, r.data);
        toast.success(`Bienvenue ${r.data.name}`);
        navigate("/");
      })
      .catch(() => {
        localStorage.removeItem("odc_token");
        navigate("/login?error=session");
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#001A3B]">
      <Logo variant="dark" />
      <div className="h-9 w-9 animate-spin rounded-full border-4 border-[#A5894E] border-t-transparent" />
      <p className="text-sm text-[#9FB2CE]">Connexion Microsoft 365 en cours…</p>
    </div>
  );
}
